export const initialValues = {
  category_id: null,
  name: "",
  is_active: 1,
};
